<template>
	<div class="empty-stream-layout">
		<div>
			<FontAwesomeIcon class="empty-stream-layout__icon" :icon="icon" />
		</div>
		<slot name="title"></slot>
		<slot name="description"></slot>
		<slot name="actions"></slot>
	</div>
</template>

<script>
export default {
	name: "EmptyStreamLayout",

	props: {
		icon: {
			type: Array,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.empty-stream-layout {
	padding: 2rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: $empty-stream-layout-bg-color;
	border: 0.0625rem solid $empty-stream-layout-border-color;
	border-radius: .5rem;
	max-width: 49rem;
}

.empty-stream-layout__icon {
	width: 1.75rem;
	height: 1.75rem;
	color: $empty-stream-layout-icon-color;
}
</style>
